import './MobileDeliveryMessage.scss';

import classnames from 'classnames';
import React from 'react';

import TRANSLATIONS from '../../../../translations/translations@default.json';

export const MobileDeliveryMessageBlock = ({
	deliveryMessage,
	stockStatus,
	deals,
}) => {
	if (!deliveryMessage || stockStatus !== 'LiveProduct') {
		return null;
	}

	let deliveryMessageWithShortMonth = deliveryMessage;

	TRANSLATIONS.delivery.shortMonthNames.forEach(function ([long, short]) {
		if (deliveryMessage.includes(long)) {
			deliveryMessageWithShortMonth = deliveryMessage.replace(long, short);
		}
	});

	const DeliveryInfo = () => (
		<div className="product-card__delivery-information-item product-card__delivery-information-item--mobile px-2">
			<i className="ico ico-delivery text-xl text-cta-main mr-1" />
			<div
				dangerouslySetInnerHTML={{
					__html: deliveryMessageWithShortMonth,
				}}
			/>
		</div>
	);

	return (
		<div
			className={classnames(
				'text-center text-body-xs bg-gray-10 py-4 rounded mt-auto',
				{ 'product-card__delivery-message-block': !deals }
			)}>
			<div className="font-bold px-2">
				<i className="ico ico-tick ico-lg text-ongreen mr-1" />
				{TRANSLATIONS.productList.productCard.stockStatus.inStock}
			</div>

			<DeliveryInfo />
		</div>
	);
};

export default MobileDeliveryMessageBlock;
